import request from '@/utils/request'
/**
    配置接口--需要多语言
**/
export function getIndexSettingApi() {
    return request.post('/api/index/get_setting');
}


/**
    登陆接口
**/
// 发送邮箱验证码
export function setSendEmailCodeApi(data) {
    return request.post('/api/common/send_email_code', data);
}
// 用户注册
export function setAuthRegisterApi(data) {
    return request.post('/api/auth/register', data);
}
// 用户登录
export function setAuthLoginApi(data) {
    return request.post('/api/auth/login', data);
}
// 忘记密码
export function setAuthForgotApi(data) {
    return request.post('/api/auth/forgot', data);
}
// 获取用户信息--需要多语言
export function getAuthInfoApi() {
    return request.post('/api/auth/info');
}


/**
    图片上传接口
**/
// 文件上传
export function setCommonUploadApi(date) {
    return request.upload('/api/common/upload', date);
}


/**
    ai生成
**/
// 获取模型列表--需要多语言
export function getModelListApi(date) {
    return request.get('/api/ai_video/model_list', date);
}
// 计算视频积分
export function setCalcVideoCreditApi(date) {
    return request.post('/api/ai_video/calc_video_credit', date);
}
// 提交视频生成任务
export function setSubmitVideoApi(date) {
    return request.post('/api/ai_video/submit_video', date);
}
// 查询视频任务状态 (轮询)
export function getQueryVideoApi(date) {
    return request.get('/api/ai_video/query_video', date);
}
// 计算图片积分
export function setCalcImageCreditApi(date) {
    return request.post('/api/ai_video/calc_image_credit', date);
}
// 提交图片生成任务
export function setSubmitImageApi(date) {
    return request.post('/api/ai_video/submit_image', date);
}
// 用户订单列表
export function getOrderListApi(date) {
    return request.get('/api/ai_video/order_list', date);
}
// 获取视频地址
export function getVideoUrlApi(date) {
    return request.post('/api/ai_video/video_url', date);
}
// 生成任务统计
export function getOrderIngtjApi(date) {
    return request.post('/api/ai_video/order_ingtj', date);
}
// 生成任务列表
export function getOrderIngApi(date) {
    return request.post('/api/ai_video/order_ing', date);
}


/**
    新闻列表
**/
// 新闻分类列表
export function getNewsCategoriesApi(date) {
    return request.get('/api/news_api/categories', date);
}
// 新闻列表
export function getNewsListApi(date) {
    return request.get('/api/news_api/list', date);
}
// 新闻详情
export function getNewsDetailApi(date) {
    return request.get('/api/news_api/detail', date);
}


/**
    会员列表
**/
// vip套餐列表--需要多语言
export function getVipListsApi(date) {
    return request.get('/api/payment/vip_list', date);
}
// 积分购买列表--需要多语言
export function getCreditPackagesApi(date) {
    return request.get('/api/payment/creditPackages', date);
}
// 创建支付订单
export function setCreateOrderApi(date) {
    return request.post('/api/payment/create_order', date);
}


/**
    会员中心
**/
// 本月总订单量
export function getOrderCountApi(date) {
    return request.get('/api/auth/orderCount', date);
}
// 积分变化--需要多语言
export function getUsageRecordsApi(date) {
    return request.get('/api/auth/usageRecords', date);
}
// 支付记录列表（账单列表）--需要多语言
export function getBillingListApi(date) {
    return request.get('/api/auth/billingList', date);
}


/**
    视频展示
**/
// 视频展示分类--需要多语言
export function getShowcaseCategoriesApi(date) {
    return request.get('/api/showcase/categories', date);
}
// 视频展示列表--需要多语言
export function getShowcaseVideosApi(date) {
    return request.get('/api/showcase/videos', date);
}
// 视频展示详情--需要多语言
export function getShowcaseDetailApi(date) {
    return request.get('/api/showcase/detail', date);
}


/**
    文章
**/
// 文章类型--需要多语言
export function getArticleCategoriesApi(date) {
    return request.get('/api/article_api/categories', date);
}
// 文章列表--需要多语言
export function getArticleListApi(date) {
    return request.get('/api/article_api/list', date);
}
// 文章详情--需要多语言
export function getArticleDetailApi(date) {
    return request.get('/api/article_api/detail', date);
}


/**
    常见问题
**/
// 常见问题分类名--需要多语言
export function getFaqCategoriesApi(date) {
    return request.get('/api/faq/categories', date);
}
// 常见问题列表--需要多语言
export function getFaqListApi(date) {
    return request.get('/api/faq/lists', date);
}


/**
    语言列表
**/
// 语言列表
export function getIndexLanguagesApi(date) {
    return request.post('/api/index/languages', date);
}